import {Component, EventEmitter, inject, Input, Output} from '@angular/core';
import {UserMetricInstance} from "../../../models/user/Metric/UserMetricInstance";
import {TranslateService} from "@ngx-translate/core";
import {BaseComponent} from "../../BaseComponent";

@Component({
  selector: 'app-hex-text-box',
  templateUrl: './hex-text-box.component.html',
  styleUrls: ['./hex-text-box.component.css']
})
export class HexTextBoxComponent extends BaseComponent {

  @Input() card?: UserMetricInstance;
  @Input() value: any;
  @Input() label: string | undefined;
  @Input() width: any = "auto";
  @Input() height: any = "auto";
  @Output() valueChange = new EventEmitter<any>();


  validateHexMin = (validationData: any) => {
    if (!this.card) return false;
    if (!validationData.value || this.card.dataTypeGroupMin === null) return true;

    // Remove '0x' prefix if present
    const hexValue = typeof validationData.value === 'string' && validationData.value.startsWith('0x')
      ? validationData.value.substring(2)
      : validationData.value;

    // Convert hex to decimal and check against min value
    const decimalValue = parseInt(hexValue, 16);
    return decimalValue >= this.card.dataTypeGroupMin;
  };

  validateHexMax = (validationData: any) => {
    if (!this.card) return false;
    if (!validationData.value || this.card.dataTypeGroupMax === null) return true;

    // Remove '0x' prefix if present
    const hexValue = typeof validationData.value === 'string' && validationData.value.startsWith('0x')
      ? validationData.value.substring(2)
      : validationData.value;

    // Convert hex to decimal and check against max value
    const decimalValue = parseInt(hexValue, 16);
    return decimalValue <= this.card.dataTypeGroupMax;
  };

  validateHexValue = (validationData: any) => {
    if (!validationData.value) return true;

    // Remove '0x' prefix if present
    const hexValue = typeof validationData.value === 'string' && validationData.value.startsWith('0x')
      ? validationData.value.substring(2)
      : validationData.value;

    // Check if the value is a valid hex number
    return /^[0-9A-Fa-f]+$/.test(hexValue);
  };
}
